import { render, staticRenderFns } from "./SelectionView.vue?vue&type=template&id=2b3310fa&scoped=true&"
import script from "./SelectionView.vue?vue&type=script&lang=js&"
export * from "./SelectionView.vue?vue&type=script&lang=js&"
import style0 from "./SelectionView.vue?vue&type=style&index=0&id=2b3310fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3310fa",
  null
  
)

export default component.exports